import React, { useEffect, useState } from "react";
import styles from "./academic-view.module.css";
import { Col, Row } from "antd";
import AcademicNonacademicStatCard from "../../../../components/academic-nonacademic-stat-card/academic-nonacademic-stat-card";
import RoutesConstant from "../../../../constants/routes";
import { useNavigate } from "react-router-dom";
import { getAcademicDepartments } from "../../../../services/teachers";
import { toast } from "react-toastify";
import EmptyLoader from "../../../../components/emptyloader/emptyloader";

const AcademicView = ({ triggerRefetch }) => {
  const navigate = useNavigate();
  const [teacherAcademicViewData, setTeacherAcademicViewData] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const resp = await getAcademicDepartments();
        const data = resp.data;

        const buildData = data?.departments?.map((item) => ({
          department: item?.department_name,
          total_students: item?.total_teachers,
          total_male: item?.male_teachers,
          total_female: item?.female_teachers,
          department_id: item?.department_id,
        }));
        setTeacherAcademicViewData(buildData);
      } catch (err) {
        console.log(err);
        toast.error("Error Retrieving Data");
      } finally {
        setLoading(false);
      }
    })();
  }, [triggerRefetch]);

  const handleViewDetails = (record) => {
    navigate(
      `${RoutesConstant.TEACHER_LIST}?id=${encodeURIComponent(
        record?.department_id
      )}`
    );
  };

  return (
    <div className={styles.main_container}>
      <EmptyLoader
        loading={loading}
        isDataAvailable={teacherAcademicViewData?.length}
      />
      <Row gutter={[16, 16]} className={styles.levels_container}>
        {teacherAcademicViewData &&
          teacherAcademicViewData.map((item, index) => (
            <Col
              style={{ cursor: "pointer" }}
              onClick={() => handleViewDetails(item)}
              className={styles.level_data}
            >
              <AcademicNonacademicStatCard
                key={index}
                level={item.department}
                total_students={item.total_students}
                total_male={item.total_male}
                total_female={item.total_female}
                is_academic={true}
                is_teachers={true}
                chart_label_1={"Male"}
                chart_label_2={"Female"}
                chart_color_1={"rgba(23, 160, 34, 1)"}
                chart_color_2={"rgba(172, 216, 30, 1)"}
              />
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default AcademicView;
